import { render, staticRenderFns } from "./PaxFormCAA.vue?vue&type=template&id=5fe10666&"
import script from "./PaxFormCAA.vue?vue&type=script&lang=ts&"
export * from "./PaxFormCAA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports